<template>
  <md-card v-if="data">
    <md-card-content>
      <ValidationObserver ref="validator">
        <md-table class="no-will-change max-w-100" v-fixedTableHeader:computed-table-header>
          <md-table-row>
            <md-table-head></md-table-head>
            <md-table-head>PVP</md-table-head>
            <md-table-head>Min</md-table-head>
            <md-table-head>Max</md-table-head>
          </md-table-row>

          <md-table-row v-for="(row, index) in queriedData" :key="index">
            <md-table-cell> {{ row.room_type }}{{ row.board }} </md-table-cell>
            <md-table-cell>
              <ValidationProvider
                :rules="`${activeFilters.board_ids.length > 0 ? 'required' : 'required|min_value:1'}`"
                v-slot="{ failed }"
              >
                <md-field :class="[{ 'md-error': failed }]">
                  <md-input type="number" size="4" v-model="row.prices.retail_price" />
                  <span v-if="units" class="md-suffix">{{ typeof units == 'string' ? units : units }}</span>
                </md-field>
              </ValidationProvider>
            </md-table-cell>
            <md-table-cell>
              <md-field>
                <md-input type="number" size="4" v-model="row.prices.minimum_price" />
                <span v-if="units" class="md-suffix">{{ typeof units == 'string' ? units : units }}</span>
              </md-field>
            </md-table-cell>
            <md-table-cell>
              <md-field>
                <md-input type="number" size="4" v-model="row.prices.maximum_price" />
                <span v-if="units" class="md-suffix">{{ typeof units == 'string' ? units : units }}</span>
              </md-field>
            </md-table-cell>
            <!-- target-table-tuple is bind to API tuple -->
            <slot v-bind:row="row"></slot>
          </md-table-row>
        </md-table>
      </ValidationObserver>
    </md-card-content>
    <md-card-actions>
      <pagination
        v-if="pagination.perPage < total"
        class="pagination-no-border pagination-primary right"
        v-model="pagination.currentPage"
        :per-page="pagination.perPage"
        :total="total"
      >
      </pagination>
      <md-button class="md-success" @click="save">Save</md-button>
    </md-card-actions>
  </md-card>
</template>

<script>
import Pagination from '@/components/Pagination'
import PaginationMixins from '@/components/PaginationMixins'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { extend } from 'vee-validate'
import { required, min_value } from 'vee-validate/dist/rules'

extend('required', required)
extend('min_value', min_value)

export default {
  name: 'TargetTableData',
  mixins: [PaginationMixins],
  components: {
    Pagination,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    endpoints: Object,
    getCellAttrs: Function,
    units: [Object, String],
    paginationEnabled: Boolean,
  },
  data() {
    return {
      activeFilters: null,
      data: false,
      pagination: {
        perPage: 20,
      },
    }
  },
  methods: {
    loadData(filters) {
      this.data = false
      this.activeFilters = Object.assign({}, filters)

      this.endpoints.compute(this.$root.hotelId, filters, (error, data) => {
        this.data = data
      })
    },
    async save() {
      if (await this.$refs.validator.validate()) {
        this.endpoints.save(this.$root.hotelId, this.endpoints.create(this.data), (error, data) => {
          if (!error) {
            this.data = data
            this.$root.$emit('saved')
          }
        })
      } else {
        alert('Form data error')
      }
    },
    clear() {
      this.data = null
    },
  },
  computed: {
    paginationEntities() {
      return this.data.rows
    },
  },
}
</script>

<style lang="scss">
.md-table.max-w-100 table {
  max-width: 100%;
  width: 100%;
}
.md-table-cell.border-right {
  border-right: 1px solid #ddd;
}

.md-table-head.flex-100 .md-table-head-label {
  width: 100%;
}
.md-table-head.flex-100 .md-table-head-label .d-flex.justify-around {
  justify-content: space-around;
}

.computed-table-header {
  line-height: normal;
  .md-table-head-container {
    height: unset;
  }
  .md-table-head-label {
    height: unset;
  }
}

.md-error {
  .md-input,
  span {
    -webkit-text-fill-color: #f44336 !important;
    color: #f44336 !important;
  }
}
</style>
